import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Home from "./home";
import About from "./about";
import Projects from "./projects";
import ProjectDetail from "./projectDetail";
import Services from "./services";
import Contact from "./contact";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/projeler" element={<Projects />} />
        <Route path="/projeler/:id" element={<ProjectDetail />} />
        <Route path="/hizmetler" element={<Services />} />
        <Route path="/iletisim" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
